/**
 * Sleep helper for retry delays.
 *
 * Creates a promise that resolves after the specified delay.
 * Useful for implementing retry logic with backoff delays.
 *
 * @param ms Milliseconds to sleep
 * @returns Promise that resolves after the delay
 *
 * @example
 * ```typescript
 * await sleep(1000); // Wait 1 second
 * console.log('Retrying...');
 * ```
 */
export const sleep = (ms: number): Promise<void> =>
  new Promise((resolve) => setTimeout(resolve, ms));
